function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import PointLocator from '../algorithm/PointLocator';
import Location from '../geom/Location';
import LineString from '../geom/LineString';
import HashMap from '../../../../java/util/HashMap';
import Geometry from '../geom/Geometry';
import hasInterface from '../../../../hasInterface';
import Position from './Position';
import Coordinate from '../geom/Coordinate';
import Point from '../geom/Point';
import Polygon from '../geom/Polygon';
import MultiPoint from '../geom/MultiPoint';
import SimpleMCSweepLineIntersector from './index/SimpleMCSweepLineIntersector';
import LinearRing from '../geom/LinearRing';
import BoundaryNodeRule from '../algorithm/BoundaryNodeRule';
import Orientation from '../algorithm/Orientation';
import SegmentIntersector from './index/SegmentIntersector';
import MultiPolygon from '../geom/MultiPolygon';
import Label from './Label';
import GeometryCollection from '../geom/GeometryCollection';
import UnsupportedOperationException from '../../../../java/lang/UnsupportedOperationException';
import CoordinateArrays from '../geom/CoordinateArrays';
import Polygonal from '../geom/Polygonal';
import IndexedPointInAreaLocator from '../algorithm/locate/IndexedPointInAreaLocator';
import Assert from '../util/Assert';
import Edge from './Edge';
import MultiLineString from '../geom/MultiLineString';
import PlanarGraph from './PlanarGraph';
var GeometryGraph = /*#__PURE__*/function (_PlanarGraph) {
  function GeometryGraph() {
    var _this;
    _classCallCheck(this, GeometryGraph);
    _this = _callSuper(this, GeometryGraph);
    GeometryGraph.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(GeometryGraph, _PlanarGraph);
  return _createClass(GeometryGraph, [{
    key: "insertBoundaryPoint",
    value: function insertBoundaryPoint(argIndex, coord) {
      var n = this._nodes.addNode(coord);
      var lbl = n.getLabel();
      var boundaryCount = 1;
      var loc = Location.NONE;
      loc = lbl.getLocation(argIndex, Position.ON);
      if (loc === Location.BOUNDARY) boundaryCount++;
      var newLoc = GeometryGraph.determineBoundary(this._boundaryNodeRule, boundaryCount);
      lbl.setLocation(argIndex, newLoc);
    }
  }, {
    key: "computeSelfNodes",
    value: function computeSelfNodes() {
      if (arguments.length === 2) {
        var li = arguments[0];
        var computeRingSelfNodes = arguments[1];
        return this.computeSelfNodes(li, computeRingSelfNodes, false);
      } else if (arguments.length === 3) {
        var _li = arguments[0];
        var _computeRingSelfNodes = arguments[1];
        var isDoneIfProperInt = arguments[2];
        var si = new SegmentIntersector(_li, true, false);
        si.setIsDoneIfProperInt(isDoneIfProperInt);
        var esi = this.createEdgeSetIntersector();
        var isRings = this._parentGeom instanceof LinearRing || this._parentGeom instanceof Polygon || this._parentGeom instanceof MultiPolygon;
        var computeAllSegments = _computeRingSelfNodes || !isRings;
        esi.computeIntersections(this._edges, si, computeAllSegments);
        this.addSelfIntersectionNodes(this._argIndex);
        return si;
      }
    }
  }, {
    key: "computeSplitEdges",
    value: function computeSplitEdges(edgelist) {
      for (var i = this._edges.iterator(); i.hasNext();) {
        var e = i.next();
        e.eiList.addSplitEdges(edgelist);
      }
    }
  }, {
    key: "computeEdgeIntersections",
    value: function computeEdgeIntersections(g, li, includeProper) {
      var si = new SegmentIntersector(li, includeProper, true);
      si.setBoundaryNodes(this.getBoundaryNodes(), g.getBoundaryNodes());
      var esi = this.createEdgeSetIntersector();
      esi.computeIntersections(this._edges, g._edges, si);
      return si;
    }
  }, {
    key: "getGeometry",
    value: function getGeometry() {
      return this._parentGeom;
    }
  }, {
    key: "getBoundaryNodeRule",
    value: function getBoundaryNodeRule() {
      return this._boundaryNodeRule;
    }
  }, {
    key: "hasTooFewPoints",
    value: function hasTooFewPoints() {
      return this._hasTooFewPoints;
    }
  }, {
    key: "addPoint",
    value: function addPoint() {
      if (arguments[0] instanceof Point) {
        var p = arguments[0];
        var coord = p.getCoordinate();
        this.insertPoint(this._argIndex, coord, Location.INTERIOR);
      } else if (arguments[0] instanceof Coordinate) {
        var pt = arguments[0];
        this.insertPoint(this._argIndex, pt, Location.INTERIOR);
      }
    }
  }, {
    key: "addPolygon",
    value: function addPolygon(p) {
      this.addPolygonRing(p.getExteriorRing(), Location.EXTERIOR, Location.INTERIOR);
      for (var i = 0; i < p.getNumInteriorRing(); i++) {
        var hole = p.getInteriorRingN(i);
        this.addPolygonRing(hole, Location.INTERIOR, Location.EXTERIOR);
      }
    }
  }, {
    key: "addEdge",
    value: function addEdge(e) {
      this.insertEdge(e);
      var coord = e.getCoordinates();
      this.insertPoint(this._argIndex, coord[0], Location.BOUNDARY);
      this.insertPoint(this._argIndex, coord[coord.length - 1], Location.BOUNDARY);
    }
  }, {
    key: "addLineString",
    value: function addLineString(line) {
      var coord = CoordinateArrays.removeRepeatedPoints(line.getCoordinates());
      if (coord.length < 2) {
        this._hasTooFewPoints = true;
        this._invalidPoint = coord[0];
        return null;
      }
      var e = new Edge(coord, new Label(this._argIndex, Location.INTERIOR));
      this._lineEdgeMap.put(line, e);
      this.insertEdge(e);
      Assert.isTrue(coord.length >= 2, 'found LineString with single point');
      this.insertBoundaryPoint(this._argIndex, coord[0]);
      this.insertBoundaryPoint(this._argIndex, coord[coord.length - 1]);
    }
  }, {
    key: "getInvalidPoint",
    value: function getInvalidPoint() {
      return this._invalidPoint;
    }
  }, {
    key: "getBoundaryPoints",
    value: function getBoundaryPoints() {
      var coll = this.getBoundaryNodes();
      var pts = new Array(coll.size()).fill(null);
      var i = 0;
      for (var it = coll.iterator(); it.hasNext();) {
        var node = it.next();
        pts[i++] = node.getCoordinate().copy();
      }
      return pts;
    }
  }, {
    key: "getBoundaryNodes",
    value: function getBoundaryNodes() {
      if (this._boundaryNodes === null) this._boundaryNodes = this._nodes.getBoundaryNodes(this._argIndex);
      return this._boundaryNodes;
    }
  }, {
    key: "addSelfIntersectionNode",
    value: function addSelfIntersectionNode(argIndex, coord, loc) {
      if (this.isBoundaryNode(argIndex, coord)) return null;
      if (loc === Location.BOUNDARY && this._useBoundaryDeterminationRule) this.insertBoundaryPoint(argIndex, coord);else this.insertPoint(argIndex, coord, loc);
    }
  }, {
    key: "addPolygonRing",
    value: function addPolygonRing(lr, cwLeft, cwRight) {
      if (lr.isEmpty()) return null;
      var coord = CoordinateArrays.removeRepeatedPoints(lr.getCoordinates());
      if (coord.length < 4) {
        this._hasTooFewPoints = true;
        this._invalidPoint = coord[0];
        return null;
      }
      var left = cwLeft;
      var right = cwRight;
      if (Orientation.isCCW(coord)) {
        left = cwRight;
        right = cwLeft;
      }
      var e = new Edge(coord, new Label(this._argIndex, Location.BOUNDARY, left, right));
      this._lineEdgeMap.put(lr, e);
      this.insertEdge(e);
      this.insertPoint(this._argIndex, coord[0], Location.BOUNDARY);
    }
  }, {
    key: "insertPoint",
    value: function insertPoint(argIndex, coord, onLocation) {
      var n = this._nodes.addNode(coord);
      var lbl = n.getLabel();
      if (lbl === null) {
        n._label = new Label(argIndex, onLocation);
      } else lbl.setLocation(argIndex, onLocation);
    }
  }, {
    key: "createEdgeSetIntersector",
    value: function createEdgeSetIntersector() {
      return new SimpleMCSweepLineIntersector();
    }
  }, {
    key: "addSelfIntersectionNodes",
    value: function addSelfIntersectionNodes(argIndex) {
      for (var i = this._edges.iterator(); i.hasNext();) {
        var e = i.next();
        var eLoc = e.getLabel().getLocation(argIndex);
        for (var eiIt = e.eiList.iterator(); eiIt.hasNext();) {
          var ei = eiIt.next();
          this.addSelfIntersectionNode(argIndex, ei.coord, eLoc);
        }
      }
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1 && arguments[0] instanceof Geometry) {
        var g = arguments[0];
        if (g.isEmpty()) return null;
        if (g instanceof MultiPolygon) this._useBoundaryDeterminationRule = false;
        if (g instanceof Polygon) this.addPolygon(g);else if (g instanceof LineString) this.addLineString(g);else if (g instanceof Point) this.addPoint(g);else if (g instanceof MultiPoint) this.addCollection(g);else if (g instanceof MultiLineString) this.addCollection(g);else if (g instanceof MultiPolygon) this.addCollection(g);else if (g instanceof GeometryCollection) this.addCollection(g);else throw new UnsupportedOperationException(g.getClass().getName());
      } else return _superPropGet(GeometryGraph, "add", this, 1).apply(this, arguments);
    }
  }, {
    key: "addCollection",
    value: function addCollection(gc) {
      for (var i = 0; i < gc.getNumGeometries(); i++) {
        var g = gc.getGeometryN(i);
        this.add(g);
      }
    }
  }, {
    key: "locate",
    value: function locate(pt) {
      if (hasInterface(this._parentGeom, Polygonal) && this._parentGeom.getNumGeometries() > 50) {
        if (this._areaPtLocator === null) {
          this._areaPtLocator = new IndexedPointInAreaLocator(this._parentGeom);
        }
        return this._areaPtLocator.locate(pt);
      }
      return this._ptLocator.locate(pt, this._parentGeom);
    }
  }, {
    key: "findEdge",
    value: function findEdge() {
      if (arguments.length === 1 && arguments[0] instanceof LineString) {
        var line = arguments[0];
        return this._lineEdgeMap.get(line);
      } else return _superPropGet(GeometryGraph, "findEdge", this, 1).apply(this, arguments);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryGraph;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "determineBoundary",
    value: function determineBoundary(boundaryNodeRule, boundaryCount) {
      return boundaryNodeRule.isInBoundary(boundaryCount) ? Location.BOUNDARY : Location.INTERIOR;
    }
  }]);
}(PlanarGraph);
export { GeometryGraph as default };
GeometryGraph.constructor_ = function () {
  this._parentGeom = null;
  this._lineEdgeMap = new HashMap();
  this._boundaryNodeRule = null;
  this._useBoundaryDeterminationRule = true;
  this._argIndex = null;
  this._boundaryNodes = null;
  this._hasTooFewPoints = false;
  this._invalidPoint = null;
  this._areaPtLocator = null;
  this._ptLocator = new PointLocator();
  if (arguments.length === 2) {
    var argIndex = arguments[0];
    var parentGeom = arguments[1];
    GeometryGraph.constructor_.call(this, argIndex, parentGeom, BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE);
  } else if (arguments.length === 3) {
    var _argIndex = arguments[0];
    var _parentGeom = arguments[1];
    var boundaryNodeRule = arguments[2];
    this._argIndex = _argIndex;
    this._parentGeom = _parentGeom;
    this._boundaryNodeRule = boundaryNodeRule;
    if (_parentGeom !== null) {
      this.add(_parentGeom);
    }
  }
};